import { render, staticRenderFns } from "./ShareLine.vue?vue&type=template&id=04d8896f&scoped=true&"
import script from "./ShareLine.vue?vue&type=script&lang=ts&"
export * from "./ShareLine.vue?vue&type=script&lang=ts&"
import style0 from "./ShareLine.vue?vue&type=style&index=0&id=04d8896f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8896f",
  null
  
)

export default component.exports